import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, SigninService, ContextService } from '../../services';
import { User, Etablissement } from '../../models';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-espace',
  templateUrl: './espace.component.html',
  styleUrls: ['./espace.component.scss']
})
export class EspaceComponent implements OnInit {

  status:boolean = false;
  currentUser: User;
  context: string;
  modalRef: BsModalRef;
  etablissements: Array<Etablissement> = [];

  constructor(
  	private userService: UserService,
    private signinService: SigninService,
    private contextService: ContextService,
    private router: Router,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

    if(this.contextService.getContext() != 'B2B'){
      this.context = '/familles';
    } else {
      this.context = '';
    }

  	this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    );

    this.currentUser.uai.forEach(function(et){
      this.signinService.checkUAI(et)
        .subscribe(etablissement => {
          //console.log(etablissement)
          this.etablissements.push(etablissement);
        });
    }, this);

  }

  toggleWindow(){
  	this.status = !this.status;
  }

  deconnect(){
  	this.userService.purgeAuth();
  	this.status = false;
  	this.currentUser = new User();
    this.modalRef.hide();
    if(this.context == '/familles'){
      this.router.navigate(['/familles']);
    } else {
      this.router.navigate(['/']);
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  hideModal(){
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/_espace/espace.component.ts